import { DeferredStateful, PromiseUtils } from "../../../Global/Base/Promises/PromiseUtils";
import { RightType } from "../../../Global/Base/Rights/RightTypes";
import { ControlWrapper } from "./ControlWrapper";
import { ILogicalContainer } from "./ILogicalContainer";

export class ContainerControlWrapper extends ControlWrapper implements ILogicalContainer {
    public readonly isContainer: boolean = true;

    /**
     * Mapa typů práv a jejich promisů.
     * Pending promise znamená, že probíhá vyhodnocení daného typu práva.
     */
    protected readonly _pendingEvaluationsMap: Map<RightType, DeferredStateful<boolean>> = new Map();

    public tryToCreatePendingRightEvaluation(rightType: RightType): boolean {
        const deferred = this._pendingEvaluationsMap.get(rightType);
        if (!deferred || deferred.isSettled) {
            this._pendingEvaluationsMap.set(rightType, PromiseUtils.deferStateful<boolean>());
            return true;
        } else {
            return false;
        }
    }

    public async waitForRightTypeEvaluation(rightType: RightType): Promise<boolean> {
        const deferred = this._pendingEvaluationsMap.get(rightType);
        if (deferred) {
            return deferred.promise;
        } else {
            return false;
        }
    }

    public resolvePendingRightTypeEvaluation(rightType: RightType): boolean {
        const deferred = this._pendingEvaluationsMap.get(rightType);
        if (deferred) {
            deferred.resolve(true);
            return true;
        }
        return false;
    }
}
